(ns app.front.view.workspace.hidden-description
  (:require [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.section :as section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::hidden?
  :<- [::ws-subs/view-data]
  (fn [{:keys [hidden?]} _]
    hidden?))

(rf/reg-sub ::hidden-data
  :<- [::ws-subs/view-data]
  (fn [view-data _]
    (select-keys view-data [:hidden-description :hidden-title-tr-key :hidden-help-tr-key])))

(defn hidden-description-content [{:keys [tr] {:keys [hidden-help-tr-key hidden-description]} :hidden-data}]
  [:div
   [:p (tr [hidden-help-tr-key])]
   [ui-rt/editor-legacy {:id            "archiving-hidden-help"
                         :initial-value hidden-description}]])

(defn hidden-description [{:keys [tr]}]
  (let [{:keys [hidden-title-tr-key] :as hidden-data} (<sub [::hidden-data])]
    (when (<sub [::hidden?])
      [section/section
       "hidden-description"
       (util/mmap tr)
       (tr [hidden-title-tr-key])
       [hidden-description-content (util/mmap tr hidden-data)]])))
